/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForGcp extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForGcp");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForGcp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForGcp>): ServiceAccountNativeDetailsBaseForGcp {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForGcp(), model);
        ServiceAccountNativeDetailsBaseForGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForGcp>): ServiceAccountNativeDetailsBaseForGcp {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForGcp.newInstance(<ServiceAccountNativeDetailsBaseForGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForGcp) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForGcp): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
